// import Image from "next/image";

// export default function AbaIcon({ name, width = 25, height = 25 }) {
//   if (!name) {
//     return;
//   }

//   // if (!width || !height) {
//   //   return <img src={`/icons/${name}.svg`} />;
//   // }
//   return (
//     <div className="iconContainer" style={{ minWidth: width, height: height }}>
//       <Image
//         src={`/icons/${name}.svg`}
//         width={width}
//         height={height}
//         alt={""}
//         // style={{ width: "inherit", display: "block" }}
//         priority
//         loading="eager"
//       />
//     </div>
//   );
// }

import dynamic from "next/dynamic";

const Usa = dynamic(() => import("/public/icons/usa-flag.svg"), {
  ssr: false,
});
const Star = dynamic(() => import("/public/icons/star.svg"), {
  ssr: true,
});
const WireGlobe = dynamic(() => import("/public/icons/wire-globe.svg"), {
  ssr: false,
});
const InfoFill = dynamic(() => import("/public/icons/info-fill.svg"), {
  ssr: false,
});
const DoubleArrow = dynamic(() => import("/public/icons/double-arrow.svg"), {
  ssr: false,
});
const Checkmark = dynamic(() => import("/public/icons/checkmark.svg"), {
  ssr: true,
});
const Info = dynamic(() => import("/public/icons/info.svg"), {
  ssr: false,
});
const Globe = dynamic(() => import("/public/icons/globe.svg"), {
  ssr: false,
});
const iCircle = dynamic(() => import("/public/icons/i-circle.svg"), {
  ssr: false,
});
const Soda = dynamic(() => import("/public/icons/soda.svg"), {
  ssr: false,
});
const SodaBottle = dynamic(() => import("/public/icons/soda-bottle.svg"), {
  ssr: false,
});
const Equal = dynamic(() => import("/public/icons/equal.svg"), {
  ssr: true,
});
const List = dynamic(() => import("/public/icons/list.svg"), {
  ssr: true,
});
const ChevronDown = dynamic(() => import("/public/icons/chevDown.svg"), {
  ssr: true,
});

const ICON_MAP = {
  Usa,
  Star,
  WireGlobe,
  InfoFill,
  DoubleArrow,
  Checkmark,
  Info,
  Globe,
  iCircle,
  Soda,
  SodaBottle,
  Equal,
  List,
  ChevronDown,
};

export default function AbaIcon({ name, color, id }) {
  const IconComponent = ICON_MAP[name];
  const iconColor = name === "Equal" ? "#1fb4ff" : color;
  return IconComponent ? (
    <IconComponent
      color={iconColor}
      id={id}
      // width={width}
      // height={height}
      // className={classnames({
      //   [className]: true,
      //   // any other styles that are common to all icons
      // })}
    />
  ) : null;
}

AbaIcon.LIST = {
  usa: "Usa",
  star: "Star",
  wireGlobe: "WireGlobe",
  infoFill: "InfoFill",
  doubleArrow: "DoubleArrow",
  checkmark: "Checkmark",
  info: "Info",
  globe: "Globe",
  iCircle: "iCircle",
  soda: "Soda",
  sodaBottle: "SodaBottle",
  equal: "Equal",
  list: "List",
  chevDown: "ChevronDown",
};
